
import { supabase } from '@/integrations/supabase/client';

export interface AuditEvent {
  event_type: string;
  details?: Record<string, any>;
  ip_address?: string;
  user_agent?: string;
}

export const logSecurityEvent = async (event: AuditEvent) => {
  try {
    const { error } = await supabase
      .from('security_audit_logs')
      .insert([{
        user_id: (await supabase.auth.getUser()).data.user?.id,
        event_type: event.event_type,
        details: event.details || {},
        ip_address: event.ip_address,
        user_agent: event.user_agent || navigator.userAgent
      }]);

    if (error) {
      console.error('Failed to log security event:', error);
    }
  } catch (error) {
    console.error('Security audit logging failed:', error);
  }
};

export const validatePhoneNumber = (phone: string): boolean => {
  // Enhanced phone number validation
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Australian mobile numbers: 04XXXXXXXX or +614XXXXXXXX
  const australianMobileRegex = /^(\+614|04)\d{8}$/;
  const internationalRegex = /^\+\d{10,15}$/;
  
  return australianMobileRegex.test(phone) || internationalRegex.test(phone);
};

export const sanitizeInput = (input: string): string => {
  return input
    .trim()
    .replace(/[<>]/g, '') // Remove potential HTML tags
    .substring(0, 1000); // Limit length
};

export const isValidUUID = (uuid: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};
